// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LaE1","right":"styles_right__27cJ6"};